import widgetFactory from '../widgetFactory';
import responsive from '../../Services/responsive';
import toucheService from '../../Services/touch';

const widgetName = 'foldable';

const widget = widgetFactory(widgetName, {
  options: {
    eventname: 'click',
    activatorSelector: '.js-foldable-button',
    initialState: 'opened',
    mobileOnly: false,
    disableOnLargeScreen: false,
  },

  _create: function () {
    this._super();

    this._createEvents();
    this._initState();
  },

  _initState: function () {
    if (this.options.initialState === 'closed') {
      this.close();
    }

    if (this.options.mobileOnly && !this.isMobile()) {
      this.forceOpen(true);
    }
  },

  _createEvents: function () {
    var self = this;

    // suppress 300ms delay on some touch device/browser
    if (this.options.eventname === 'click' && toucheService.isTouch()) {
      this.options.eventname = 'tap';
    }

    this.element
      .on('click', '.js-foldable-nolink', function (event) {
        event.preventDefault();
      })
      .on(this.options.eventname, this.options.activatorSelector, function () {
        self.toggle();
      });
  },

  isMobile: function () {
    if (responsive.getCurrent() === 'small' || responsive.getCurrent() === 'medium') {
      return true;
    }
  },

  isOpened: function () {
    return !this.element.hasClass('is-closed');
  },

  open: function () {
    this.element.removeClass('is-closed');
  },

  close: function () {
    this.element.addClass('is-closed');
  },

  toggle: function () {
    if (this.isOpened()) {
      this.close();
    } else {
      this.open();
    }
  },

  forceOpen: function (state) {
    if (this.options.disableOnLargeScreen || this.options.mobileOnly) {
      this.element.toggleClass('is-forceOpened', state);
    } else {
      this._initState();
    }
    if (!state) {
      this._initState();
    }
  },
});

export default widget;
